/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const moreHorizontal = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M11 13h2v-2h-2v2zm-6 0h2v-2H5v2zm12-2v2h2v-2h-2z" />
	</SVG>
);

export default moreHorizontal;
